import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faEnvelope,
  faMobileAlt,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ServiceFour from "../assets/service-4.png";
import ContactSection from "../common/ContactAs";
import NavigationBar from "../common/NavigationBar";


const GetInTouch = () => {
  return (
    <div id="get-in-touch" className="touch-container">
      <div className="touch-top-bar">
        <NavigationBar />
      </div>
      <div className="newcontact-container">
        <span className="newcontact-subtitle">CONTACT US</span>
        <div className="newcontact-left-section">
          {/* <h2>We're open to talk to good people.</h2> */}
          <div className="newcontact-item">
            <FontAwesomeIcon
              icon={faMapMarkerAlt}
              className="newcontact-icon"
            />
            <p>
              SM Gardenia,Flat No- 203, Sorahunse, Varthur, Bangalore -560087
            </p>
          </div>
          <div className="map">
            <a
              href="https://www.google.com/maps?q=StinSoft+Technologies+Private+Limited,+ELCOT+SEZ+IT+Park,+G6,+Jagir+Ammapalayam,+Salem,+Tamil+Nadu"
              target="_blank"
              rel="noopener noreferrer"
              className="newcontact-link"
              aria-label="View location on Google Maps"
            >
              SEE MAP <FontAwesomeIcon icon={faArrowRight} className="icons" />
            </a>
          </div>
          <div className="newcontact-item">
            <FontAwesomeIcon icon={faEnvelope} className="newcontact-icon" />
            <p>support@rightlender.in</p>
          </div>
          <div className="map">
            <a
              href="mailto:support@rightlender.in"
              className="newcontact-link"
              aria-label="Send an email"
            >
              SAY HELLO{" "}
              <FontAwesomeIcon icon={faArrowRight} className="icons" />
            </a>
          </div>

          <div className="newcontact-item">
            <FontAwesomeIcon icon={faMobileAlt} className="newcontact-icon" />
            <p>86103 25366</p>
          </div>
          <div className="map">
            <a
              href="tel:+18376528800"
              className="newcontact-link"
              aria-label="Call now"
            >
              CALL NOW <FontAwesomeIcon icon={faArrowRight} />
            </a>
          </div>
        </div>

        <div className="newcontact-image-section">
          <img src={ServiceFour} alt="Contact Us" className="inline-img" />
        </div>

        <div className="newcontact-right-section">
          <h4>Get in Touch</h4>
          <form className="newcontact-form">
            <div className="form-row">
              <div className="newcontact-form-group">
                <h5>Name</h5>
                <input
                  type="text"
                  id="name"
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div className="newcontact-form-group">
                <h5 htmlFor="email">Email</h5>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>
            <div className="newcontact-form-group">
              <h5 htmlFor="message">Message</h5>
              <textarea
                id="message"
                placeholder="Enter your message"
                required
              ></textarea>
            </div>
            <div className="form-footer">
              {/* <div className="left-col">
                <button type="submit" className="submit-btn">
                  SEND MESSAGE
                </button>
              </div> */}
              <div className="right-col">
                <p>
                  <i
                    className="fas fa-info-circle"
                    style={{ marginRight: "7px", color: "grey" }}
                  ></i>
                  All the fields are required. By sending the form you agree to
                  the <Link to="/terms-conditions">Terms & Conditions</Link> and{" "}
                  <Link to="/privacy-policy">Privacy Policy</Link>.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ContactSection />
    </div>
  );
};

export default GetInTouch;
